import { Component, ViewEncapsulation, computed, input, output, signal } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SocialNetwork } from '../../../../account-v2/src/app/api/socialNetwork';
import { CapitalizePipe } from '../../advocacy-group/contest-sheets/contest-sheets.pipes';

/**
 * Broadcast "share image ready" step — shows the rendered share image and a
 * template-driven form for the share message, and emits share/download/reprocess
 * actions to the host flow.
 */
@Component({
    selector: 'ft-broadcast-share-image-ready-ng',
    imports: [FormsModule, TranslateModule, CapitalizePipe],
    encapsulation: ViewEncapsulation.None,
    templateUrl: './ft-broadcast-share-image-ready.component.html',
    styleUrls: ['./ft-broadcast-share-image-ready.component.scss'],
})
export class FtBroadcastShareImageReadyComponent {
    readonly shareType = input<any>();
    readonly shareImageUrl = input<any>();
    readonly network = input<any>();
    readonly shareUrl = input<any>();
    readonly first = input<any>();
    readonly isRecommendationSetup = input(false);
    readonly reprocessImage = output<void>();
    readonly downloadShareImage = output<void>();
    /** v1 `on-share="$ftFlow.openOAuth(message)"` — emits the share message. */
    readonly share = output<any>();

    protected readonly message = signal<any>(undefined);

    protected readonly isInstagram = computed<boolean>(() => this.network() && this.network().type == SocialNetwork.Instagram);

    protected readonly isTwitter = computed<boolean>(() => this.network() && this.network().type == SocialNetwork.Twitter);

    protected readonly isLinkedIn = computed<boolean>(() => this.network() && this.network().type == SocialNetwork.LinkedIn);

    protected submitShare(form: NgForm): void {
        if (form.invalid) return;
        this.share.emit(this.message());
    }

    protected onDownloadShareImage(): void {
        this.downloadShareImage.emit();
    }

    protected onReprocessImage(): void {
        this.reprocessImage.emit();
    }
}
